
export function Toggle({ label, active }) {
    return (
        <div className='complete-toggle'>
            <div data-testid={'toggle1'} className="toggle-comp">
                <div data-testid={'toggle2'} className={`toggle ${active && 'active-toggle'}`}>
                </div>
            </div>
            <p className="normal-text grey-600">{label}</p>
        </div>

    )
}

    export const ToggleTailWind = ({ enabled, onToggle }) => {
        return (
            <button
                onClick={(event) => { event.stopPropagation(); onToggle(!enabled); }    }
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${enabled ? "bg-sky-700" : "bg-slate-300"
                    }`}
            >
                <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${enabled ? "translate-x-5" : "translate-x-1"
                        }`}
                />
            </button>
        );
    };